import React, { useEffect } from "react";
import "./ToggleButton.css";

export default function ToggleButton({ text1, text2, selected, onChange }) {
    const [isToggled, setIsToggled] = React.useState(selected || false);

    useEffect(() => {
        setIsToggled(selected || false);
    }, [selected]);

    const toggle = () => {
        const newState = !isToggled;
        setIsToggled(newState);
        if (onChange) {
            onChange(newState);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
        }
    };

    return (
        <div
            className="toggle-button-container"
            onClick={toggle}
            onKeyDown={handleKeyPress}
            tabIndex={0}
            role="switch"
            aria-checked={isToggled}
            aria-label={`Toggle between ${text1} and ${text2}`}
        >
            <div className="toggle-buttons">
                <p className={isToggled ? "toggle-button-selected" : "toggle-button-unselected"}>
                    {text1}
                </p>
                <p className={!isToggled ? "toggle-button-selected" : "toggle-button-unselected"}>
                    {text2}
                </p>
            </div>
        </div>
    );
}